import React, { useState, useEffect } from 'react';
import './style.css';

const NARUTO_CHARACTERS = {
  naruto_progression: [
    "Naruto Uzumaki (Part 1)",
    "Naruto Uzumaki (Early Shippuden)",
    "Naruto Uzumaki (Sage Mode)",
    "Naruto Uzumaki (KCM1)",
    "Naruto Uzumaki (KCM2)",
    "Naruto Uzumaki (Six Paths)"
  ],
  sasuke_progression: [
    "Sasuke Uchiha (Part 1)",
    "Sasuke Uchiha (Curse Mark)",
    "Sasuke Uchiha (Hebi)",
    "Sasuke Uchiha (Taka)",
    "Sasuke Uchiha (EMS)",
    "Sasuke Uchiha (Rinnegan)"
  ],
  madara_progression: [
    "Madara Uchiha (Alive)",
    "Madara Uchiha (Reanimated)",
    "Madara Uchiha (Restored)",
    "Madara Uchiha (Ten-Tails Jinchuriki)",
    "Madara Uchiha (Dual Rinnegan)",
    "Madara Uchiha (Three-Eyed)"
  ],
  obito_progression: [
    "Obito Uchiha (Young)",
    "Obito Uchiha (Masked Man)",
    "Obito Uchiha (War Arc)",
    "Obito Uchiha (Ten-Tails Jinchuriki)",
    "Obito Uchiha (Dual Sharingan)"
  ],
  kabuto_progression: [
    "Kabuto Yakushi (Part 1)",
    "Kabuto Yakushi (Shippuden)",
    "Kabuto Yakushi (Snake Sage Mode)"
  ],
  orochimaru_progression: [
    "Orochimaru (Part 1)",
    "Orochimaru (Weakened)",
    "Orochimaru (Restored)"
  ],
  gaara_progression: [
    "Gaara (Part 1)",
    "Gaara (Kazekage)",
    "Gaara (War Arc)"
  ],
  might_guy_progression: [
    "Might Guy (Base)",
    "Might Guy (Seven Gates)",
    "Might Guy (Eight Gates)"
  ],
  pain_progression: [
    "Pain (Six Paths)",
    "Pain (Deva Path Only)",
    "Nagato (Prime)",
    "Nagato (Reanimated)"
  ],
  itachi_progression: [
    "Itachi Uchiha (Alive)",
    "Itachi Uchiha (Reanimated)"
  ],
  minato_progression: [
    "Minato Namikaze (Alive)",
    "Minato Namikaze (Reanimated)",
    "Minato Namikaze (KCM)"
  ],
  hashirama_progression: [
    "Hashirama Senju (Alive)",
    "Hashirama Senju (Reanimated)"
  ],
  tobirama_progression: [
    "Tobirama Senju (Alive)",
    "Tobirama Senju (Reanimated)"
  ],
  hiruzen_progression: [
    "Hiruzen Sarutobi (Prime)",
    "Hiruzen Sarutobi (Old)",
    "Hiruzen Sarutobi (Reanimated)"
  ],
  kakashi_progression: [
    "Kakashi Hatake (Part 1)",
    "Kakashi Hatake (Shippuden)",
    "Kakashi Hatake (Double Sharingan)",
    "Kakashi Hatake (DMS)"
  ],
  sakura_progression: [
    "Sakura Haruno (Part 1)",
    "Sakura Haruno (Shippuden)",
    "Sakura Haruno (War Arc - 100 Healings)"
  ],
  tsunade_progression: [
    "Tsunade (Pre-Healing)",
    "Tsunade (100 Healings)"
  ],
  killer_bee_progression: [
    "Killer B (Base)",
    "Killer B (V2 Cloak)",
    "Killer B (Full Eight-Tails)"
  ],
  onoki_progression: [
    "Onoki (Prime)",
    "Onoki (Old)",
    "Onoki (War Arc)"
  ],
  danzo_progression: [
    "Danzo (Base)",
    "Danzo (Sharingan Unsealed)"
  ],
  kimimaro_progression: [
    "Kimimaro (Base)",
    "Kimimaro (Curse Mark)"
  ],
  jugo_progression: [
    "Jugo (Calm)",
    "Jugo (Berserk)"
  ],
  single_state_characters: [
    // Konoha
    "Shikamaru Nara",
    "Choji Akimichi",
    "Ino Yamanaka",
    "Rock Lee",
    "Neji Hyuga",
    "Tenten",
    "Hinata Hyuga",
    "Kiba Inuzuka",
    "Shino Aburame",
    "Kurenai Yuhi",
    "Asuma Sarutobi",
    "Yamato",
    "Sai",
    "Shisui Uchiha",
    "Fugaku Uchiha",
    "Anko Mitarashi",
    "Ibiki Morino",
    "Ebisu",
    "Hayate Gekko",
    "Genma Shiranui",
    "Aoba Yamashiro",
    "Yugao Uzuki",
    "Izumo Kamizuki",
    "Kotetsu Hagane",
    "Iruka Umino",
    // Akatsuki
    "Konan",
    "Kisame Hoshigaki",
    "Sasori",
    "Deidara",
    "Kakuzu",
    "Hidan",
    "White Zetsu",
    "Black Zetsu",
    // Sand Village
    "Kankuro",
    "Temari",
    "Rasa",
    "Chiyo",
    "Pakura",
    "Maki",
    "Baki",
    // Cloud Village
    "A (Third Raikage)",
    "A (Fourth Raikage)",
    "Darui",
    "C",
    "Samui",
    "Karui",
    "Omoi",
    "Yugito Nii",
    "Dodai",
    // Mist Village
    "Yagura",
    "Mei Terumi",
    "Zabuza Momochi",
    "Haku",
    "Chojuro",
    "Ao",
    "Suigetsu Hozuki",
    "Mangetsu Hozuki",
    "Jinpachi Munashi",
    "Kushimaru Kuriarare",
    "Ameyuri Ringo",
    "Fuguki Suikazan",
    // Stone Village
    "Mu",
    "Kitsuchi",
    "Kurotsuchi",
    "Akatsuchi",
    "Han",
    "Roshi",
    // Sound Village
    "Tayuya",
    "Kidomaru",
    "Sakon and Ukon",
    "Jirobo",
    // Others
    "Mifune",
    "Hanzo",
    "Karin",
    "Fu",
    "Utakata",
    "Toroi",
    "Kaguya Otsutsuki"
  ]
};

 // Flatten the character groups into a single array
const characters = Object.values(NARUTO_CHARACTERS).flat();

const MAX_QUESTIONS = 500; // Increased due to larger character pool

export default function App() {
  const [sortedList, setSortedList] = useState([characters[0]]);
  const [unsortedList, setUnsortedList] = useState(characters.slice(1));
  const [currentChar, setCurrentChar] = useState(null);
  const [compareIndex, setCompareIndex] = useState(0);
  const [questionCount, setQuestionCount] = useState(0);
  const [history, setHistory] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const setupNextComparison = () => {
    setIsLoading(true);
    
    if (unsortedList.length === 0) {
      setIsComplete(true);
      setIsLoading(false);
      return;
    }

    const nextChar = unsortedList[0];
    const remainingUnsorted = unsortedList.slice(1);

    setCurrentChar(nextChar);
    setUnsortedList(remainingUnsorted);
    setCompareIndex(0);
    setIsLoading(false);
  };

  useEffect(() => {
    if (questionCount >= MAX_QUESTIONS) {
      forceComplete();
      return;
    }

    if (!isComplete && !currentChar && !isLoading) {
      setupNextComparison();
    }
  }, [currentChar, isComplete, questionCount, isLoading]);

  const forceComplete = () => {
    setSortedList(prev => {
      const allRemaining = currentChar ? [currentChar, ...unsortedList] : unsortedList;
      return [...prev, ...allRemaining];
    });
    setIsComplete(true);
  };

  const makeChoice = (stronger) => {
    if (isLoading) return;

    const newHistory = [...history, {
      char1: currentChar,
      char2: sortedList[compareIndex],
      choice: stronger,
      compareIndex: compareIndex,
      sortedList: [...sortedList],
      unsortedList: [...unsortedList]
    }];
    setHistory(newHistory);
    setQuestionCount(prev => prev + 1);

    if (stronger === currentChar) {
      if (compareIndex + 1 >= sortedList.length) {
        setSortedList(prev => [...prev, currentChar]);
        setCurrentChar(null);
      } else {
        setCompareIndex(prev => prev + 1);
      }
    } else {
      setSortedList(prev => [
        ...prev.slice(0, compareIndex),
        currentChar,
        ...prev.slice(compareIndex)
      ]);
      setCurrentChar(null);
    }
  };

  const removeCharacter = (characterToRemove) => {
    if (characterToRemove === currentChar) {
      setUnsortedList(prev => prev.filter(char => char !== characterToRemove));
      setCurrentChar(null);
    } else {
      setSortedList(prev => prev.filter(char => char !== characterToRemove));
      // Add the current character to sorted list at the current position
      setSortedList(prev => [
        ...prev.slice(0, compareIndex),
        currentChar,
        ...prev.slice(compareIndex)
      ]);
      setCurrentChar(null);
    }
    setQuestionCount(prev => prev + 1);
  };

  const skipComparison = () => {
    if (isLoading) return;

    setHistory(prev => [...prev, {
      char1: currentChar,
      char2: sortedList[compareIndex],
      choice: 'skipped',
      compareIndex: compareIndex,
      sortedList: [...sortedList],
      unsortedList: [...unsortedList]
    }]);

    setSortedList(prev => [...prev, currentChar]);
    setCurrentChar(null);
    setQuestionCount(prev => prev + 1);
  };

  const undo = () => {
    if (history.length === 0) return;

    const lastAction = history[history.length - 1];
    setSortedList(lastAction.sortedList);
    setUnsortedList(lastAction.unsortedList);
    setCurrentChar(lastAction.char1);
    setCompareIndex(lastAction.compareIndex);
    setQuestionCount(prev => prev - 1);
    setHistory(prev => prev.slice(0, -1));
    setIsComplete(false);
  };

  return (
    <div className="container">
      <h1>Naruto Power Rankings</h1>
      <div className="question-counter">
        Question {questionCount + 1}
        {questionCount > 0 && ` (${MAX_QUESTIONS - questionCount} remaining)`}
      </div>
      
      {!isComplete ? (
        <div className="comparison-container">
          {isLoading ? (
            <div className="loading-text">Setting up next comparison...</div>
          ) : currentChar && sortedList[compareIndex] ? (
            <>
              <div className="versus-text">Who is stronger?</div>
              <div className="character-comparison">
                <div className="character-slot">
                  <button 
                    className="character-button"
                    onClick={() => makeChoice(currentChar)}
                  >
                    {currentChar}
                  </button>
                  <button 
                    className="dont-know-button"
                    onClick={() => removeCharacter(currentChar)}
                  >
                    Don't Know This Character
                  </button>
                </div>

                <div className="vs">VS</div>

                <div className="character-slot">
                  <button 
                    className="character-button"
                    onClick={() => makeChoice(sortedList[compareIndex])}
                  >
                    {sortedList[compareIndex]}
                  </button>
                  <button 
                    className="dont-know-button"
                    onClick={() => removeCharacter(sortedList[compareIndex])}
                  >
                    Don't Know This Character
                  </button>
                </div>
              </div>
              <div className="action-buttons">
                <button 
                  className="skip-button"
                  onClick={skipComparison}
                >
                  Skip This Comparison
                </button>
              </div>
            </>
          ) : (
            <div className="loading-text">Setting up next comparison...</div>
          )}
          <button 
            className="undo-button" 
            onClick={undo}
            disabled={history.length === 0}
          >
            Undo
          </button>
        </div>
      ) : (
        <div className="final-rankings">
          <h2>Final Rankings</h2>
          <ol>
            {[...sortedList].reverse().map((character, index) => (
              <li key={index}>{character}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}